/* eslint-disable @typescript-eslint/naming-convention */ // pre-commit-allow: PascalCase fields mirror the C# Sparta DTO contract, same as every sibling DTO in this folder (#29496)

export class PerDiemRuleRateDto {
  public PlantPerDiemRuleRateID: string | null = null;
  public RateLabel: string | null = null;
  public Rate: number | null = null;
  /** Craft/Class scope the rate to one classification; both null = the flat default rate (WI 30859). */
  public Craft: string | null = null;
  public Class: string | null = null;
  public bActive = true;
}

export class PerDiemRuleDocTypeDto {
  public PlantPerDiemRuleDocTypeID: string | null = null;
  public DocTypeName: string | null = null;
  public bNotarizedRequired = false;
  public DatedWithinDays: number | null = null;
  public ConditionText: string | null = null;
  public bActive = true;
}

export class PerDiemRuleDto {
  public PlantPerDiemRuleID: string | null = null;
  public PlantID: number | null = null;
  public IsEligible = true;
  public DistanceThresholdMiles: number | null = null;
  public MileageCapMilesPerTrip: number | null = null;
  public Notes: string | null = null;
  public Rates: PerDiemRuleRateDto[] = [];
  public DocTypes: PerDiemRuleDocTypeDto[] = [];
  /**
   * Payload capability flag (WI 30859): set true only by editors that display
   * classification-scoped rates. While false, the API treats null Craft/Class as
   * "not specified" and never deactivates class rates this payload could not carry.
   */
  public IncludesClassificationRates = false;
}

/**
 * Human-readable summary of a document's conditions, e.g.
 * "Must be notarized · Dated within 60 days · Must state all bills paid".
 * Empty string when the document has no conditions.
 *
 * Lives beside the DTO so every consumer (plant setup, dispatch dialog,
 * recruiter per diem tab) phrases conditions identically (#29741).
 */
export function describePerDiemDocCondition(
  docType: PerDiemRuleDocTypeDto
): string {
  const parts: string[] = [];

  if (docType.bNotarizedRequired) {
    parts.push('Must be notarized');
  }
  if (
    docType.DatedWithinDays !== null &&
    docType.DatedWithinDays !== undefined
  ) {
    parts.push(`Dated within ${docType.DatedWithinDays} days`);
  }
  if (docType.ConditionText?.trim()) {
    parts.push(docType.ConditionText.trim());
  }

  return parts.join(' · ');
}
